import { useMutation } from "@tanstack/react-query";
import { apiPost } from "../client";

interface SaveAnswerParams {
  id: string;
  data: {
    question_id: string;
    selected_answer: string;
    excluded_choices: string[];
    marked_for_review: boolean;
  };
}

export function useSaveAnswers() {
  return useMutation({
    mutationFn: async ({ id, data }: SaveAnswerParams) => {
      const res = await apiPost<unknown>(`/exam_progress/${id}/answers`, data);
      return res;
    },
  });
}
